export default "__VITE_ASSET__1935d118__"